import { render, staticRenderFns } from "./Coins.vue?vue&type=template&id=1f90c52e&scoped=true&"
import script from "./Coins.vue?vue&type=script&lang=js&"
export * from "./Coins.vue?vue&type=script&lang=js&"
import style0 from "./Coins.vue?vue&type=style&index=0&id=1f90c52e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f90c52e",
  null
  
)

export default component.exports